import { useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";
import { useApi } from "../hooks/useApi";
import { useAuth } from "../context/AuthContext";
import { ErrorState, Loading, PageHeader, Segmented } from "../components/common";
import { ProjectsTable } from "../components/ProjectsTable";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";

export default function Projects() {
  const { isPartner } = useAuth();
  const [sp, setSp] = useSearchParams();
  const pot = sp.get("pot") || "All";
  const status = sp.get("status") || "All";
  const partner = sp.get("partner") || "all";
  const q = sp.get("q") || "";
  const set = (k, v, def) => { const n = new URLSearchParams(sp); if (v === def || !v) n.delete(k); else n.set(k, v); setSp(n, { replace: true }); };
  const params = { pot, status, ...(partner !== "all" ? { partner_id: partner } : {}), ...(q ? { q } : {}) };
  const { data, error, status: code, loading } = useApi("/projects", { params });
  const partners = useApi(isPartner ? null : "/partners");

  return (
    <div data-testid="projects-page">
      <PageHeader eyebrow={isPartner ? "Your projects" : "JV Summary"} title="Projects"
        subtitle={data ? `${data.all_count} projects · ${data.counts.Live} Live · ${data.counts.Pipeline} Pipeline · ${data.counts.Exited} Exited` : " "} />
      <div className="mb-4 flex flex-wrap items-center gap-3" data-testid="projects-filters">
        {!isPartner && <Segmented options={["All", "AMSM", "AM"]} value={pot} onChange={(v) => set("pot", v, "All")} testid="filter-pot" />}
        <Segmented options={["All", "Live", "Pipeline", "Exited"]} value={status} onChange={(v) => set("status", v, "All")} testid="filter-status" />
        {!isPartner && (
          <Select value={partner} onValueChange={(v) => set("partner", v, "all")}>
            <SelectTrigger className="w-56 h-9" data-testid="filter-partner"><SelectValue placeholder="All partners" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all" data-testid="filter-partner-all">All partners</SelectItem>
              {(partners.data || []).map((p) => <SelectItem key={p.id} value={p.id} data-testid={`filter-partner-option-${p.name.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}>{p.name}</SelectItem>)}
            </SelectContent>
          </Select>
        )}
        <div className="relative">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <input value={q} onChange={(e) => set("q", e.target.value, "")} placeholder="Search project, SPV, partner"
            className="h-9 w-64 rounded-md border bg-card pl-9 pr-3 text-sm outline-none focus:ring-2 focus:ring-primary" data-testid="projects-search-input" />
        </div>
        {data && <span className="text-sm text-muted-foreground" data-testid="projects-shown-count">{data.rows.length} shown</span>}
      </div>
      {loading && !data ? <Loading /> : error && !data ? <ErrorState message={error} status={code} /> : (
        <ProjectsTable rows={data.rows} totals={data.totals} showPartner={!isPartner} />
      )}
    </div>
  );
}
